export const environment = {
  production: true,
  environmentName: 'production',
  googleMapsKey: 'AIzaSyCpMKld7CtFpjBpdbZcbR1FUN5HsxXd7EM',
  clientID: '3f04d4ba-fe18-41fb-b99f-917593669fd6',
  authority: 'https://trinityAirMedB2C.b2clogin.com/trinityAirMedB2C.onmicrosoft.com/',
  redirectUri: 'https://app.trinityairmedical.com',
  signInOkta: 'B2C_1_Okta_SignIn', // trinity realm
  signInStrata: 'B2C_1_Strata_Okta_SignIn', // stratacritical realm
  signInSrta: 'B2C_1_Srta_Okta_SignIn', // srta realm
  signIn: 'B2C_1_SignIn_TAM',
  signUp: 'B2C_1_SignUp_TAM',
  resetPassword: 'B2C_1_Reset_Password_TAM',
  apiScope: 'https://trinityAirMedB2C.onmicrosoft.com/api-tam-test/Read',
  authorizePath: '/oauth2/v2.0/authorize',
  tokenPath: '/oauth2/v2.0/token',
  apiUrl: 'https://as-tac-prod-server.azurewebsites.net/api',
  apiHost: 'https://as-tac-prod-server.azurewebsites.net/api/v1',
  apiHostV2: 'https://as-tac-prod-server.azurewebsites.net/api/v2',
  redirectURL: 'https://app.trinityairmedical.com/#/track-itinerary',
  baseUrl: 'https://app.trinityairmedical.com/#',
  sseEndpoint: 'https://as-tac-prod-server.azurewebsites.net/',
  oktaRedirectUri: 'https%3A%2F%2Ftrinityairmedical.okta.com',
  strataRedirectUri: 'https%3A%2F%2Fgo.stratacritical.com',
  srtaRedirectUri: 'https%3A%2F%2Fgo.srta.com',
  sentryDsn: 'https://b06da3bd924de3fcd03744eb827923b9@o4510155090755584.ingest.us.sentry.io/4510307570679808',

  isNSEnabled: true,
  isOktSSOEnable: true,
  isFlightAwareAPIActive: false,
  isEnableGeoFencingForGroundLegs: true,
};
